<template>
  <div class="login-page">
    <el-card class="login-card">
      <div slot="header">故事管理系统登录</div>
      <el-form label-width="60px" @submit.native.prevent="handleLogin">
        <el-form-item label="账号">
          <el-input v-model="loginForm.username" placeholder="请输入用户名" />
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" native-type="submit" style="width: 100%" :loading="loginLoading">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { login } from "@/net/api";

export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        username: "",
        password: ""
      },
      loginLoading: false
    };
  },
  methods: {
    async handleLogin() {
      if (!this.loginForm.username || !this.loginForm.password) {
        return this.$message.warning("请输入用户名和密码");
      }
      this.loginLoading = true;
      try {
        const res = await login(this.loginForm);
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("user", JSON.stringify(res.data.user));
        this.$message.success("登录成功");
        this.$router.push("/");
      } catch (e) {
        console.error(e);
        this.$message.error(e.response?.data?.message || "登录失败");
      } finally {
        this.loginLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.login-page {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f2f5;
}
.login-card {
  width: 400px;
}
</style>
